export enum PartnerDomainFormFields {
  Domain = 'domain',
}

export type PartnerDomainFormModel = {
  [PartnerDomainFormFields.Domain]: string;
};
